import { SimplePage } from "@/app/_/marketing/SimplePage";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="FAQ"
      title="Frequently asked questions."
      subtitle="Answers to the questions we hear most often about Neoledger — security, data handling, pricing, migration, and more."
      secondaryCta={{
        label: "Contact us",
        to: "/company/contact",
      }}
      primaryCta={{
        label: "Join waitlist",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
    />
  );
}
